import { useEffect, useState } from 'react'
import { Button, Col, Modal, Spinner } from 'react-bootstrap'
import { Request } from '../../../Api/Requests/models'
import { BsDashCircleFill } from 'react-icons/bs'
import { getTotalAmount } from '../../../Api/Requests/Requests'
import { RejectRequestModal } from './RejectRequestModal'
import { useAutoSubtract } from '../hooks/useAutoSubtract'
import toast from 'react-hot-toast'
import { openImage } from '../../../../../Utils/images'

interface OpenRequestModalProps {
    show: boolean
    onHide: () => void
    request: Request
}

export const OpenSubtractRequest = ({ show, onHide, request }: OpenRequestModalProps) => {
    //Total amount states
    const [failedTotalAmount, setFailedTotalAmount] = useState(false)
    const [totalAmount, setTotalAmount] = useState(0)
    const [lastUpdate, setLastUpdate] = useState('')
    const [showReject, setShowReject] = useState(false)
    const [loadingTotalAmount, setLoadingTotalAmount] = useState(false)
    const [updatedRequest, setUpdatedRequest] = useState(request)

    const { handleSubtractCoins, loadingSubtract } = useAutoSubtract({ request: updatedRequest, onHide })

    const closeBothModals = () => {
        setShowReject(false)
        onHide()
    }

    const verifyAndSubmit = () => {
        if (updatedRequest.amount > totalAmount) {
            toast.error('El jugador no tiene suficientes fichas disponibles. Actualice el saldo y vuelva a intentar.')
            return;
        } else {
            handleSubtractCoins()
        }
    }

    const fetchTotalAmount = async () => {
        setLoadingTotalAmount(true)
        const res = await getTotalAmount({ name: request.Player?.platformUser })
        if (!res?.totalAmount) {
            setFailedTotalAmount(true)
        } else {
            setTotalAmount(res?.totalAmount)
            setFailedTotalAmount(false)
        }
        setLastUpdate(new Date().toLocaleString())
        setLoadingTotalAmount(false)
    }
    useEffect(() => {
        fetchTotalAmount()
        setUpdatedRequest(request)
    }, [])


    const lastProofOfLoad = request.lastProofOfLoad ? `${process.env.REACT_APP_API}${request.lastProofOfLoad}` : null
    return (
        <>
            <RejectRequestModal show={showReject} onHide={() => setShowReject(false)} closeBothModals={closeBothModals} request={request} />

            <Modal show={show} onHide={onHide} size='lg' backdrop="static" keyboard={false} centered>
                <div className="border border-secondary rounded-3 px-4">
                    <Modal.Header closeButton>
                        <Modal.Title>Solicitud de {request.type === 'load' ? 'Carga' : 'Retiro'}<br /> <span className='text-primary'>{request.Player?.platformUser}</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <div className='d-flex justify-content-between gap-2 align-items-center'>
                            <div className='text-center d-flex justify-content-center w-75 text-primary'>
                                El usuario {request.Player?.platformUser} desea {request.type === 'load' ? 'cargar' : 'retirar'} {request.amount} fichas.
                            </div>
                            <div className='d-flex flex-column gap-2'>
                                {lastProofOfLoad && (
                                    <div role='button' className='d-flex flex-column gap-2 justify-content-center align-items-center'>
                                        <img src={lastProofOfLoad} alt="Comprobante" width={100} onClick={() => openImage(lastProofOfLoad ?? '')} />
                                        <div className='text-secondary text-center w-100 text-xxs'>Último comprobante de carga</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />

                        <div className="mt-2">
                            Solicitud de <span className="text-primaryy">Retiro</span>
                        </div>
                        <div className="mt-2">
                            Titular cuenta destinatario: <span className="text-primaryy">{request.recipient ?? '-'}</span>
                        </div>
                        <div className="mt-2">
                            CBU del destinatario: <span className="text-primaryy">{request.recipientBankAccount}</span>
                        </div>
                        <Col md={4} className="mt-2">
                            Cantidad: <input type="number" className="text-primaryy form-control" value={updatedRequest.amount} onChange={(e) => setUpdatedRequest({ ...updatedRequest, amount: Number(e.target.value) })} />
                        </Col>

                        <div className='mt-2'>Comentarios:
                            <textarea className="text-primaryy form-control"
                                value={updatedRequest.reason ?? ''}
                                onChange={(e) => setUpdatedRequest({ ...updatedRequest, reason: e.target.value })}
                            />
                        </div>
                        <div className='text-secondary text-xs text-end'>* Los comentarios serán visibles para el cliente.</div>
                        <hr />
                        <div className='my-5 d-flex justify-content-between gap-2 align-items-center'>
                            <div>
                                El usuario actualmente tiene: <span className="text-primaryy">{totalAmount}</span> fichas disponibles.
                                <div>
                                    <span className='text-secondary'>Última Actualización: </span> <span className="text-primaryy">{lastUpdate}</span>
                                </div>
                            </div>
                            <div>
                                <Button variant="primary" onClick={() => fetchTotalAmount()} disabled={loadingTotalAmount}>{loadingTotalAmount ? <Spinner animation="border" size="sm" /> : 'Actualizar'}</Button>
                            </div>
                        </div>

                        {failedTotalAmount &&
                            <div className='mt-2 text-danger text-center'>
                                No se pudo obtener el total de fichas del usuario.
                            </div>
                        }

                        <div className='mt-2 text-warning text-center'>
                            Verifica que estos datos sean correctos, y que el usuario tenga suficientes fichas disponibles.
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-between w-100'>

                            <div className='d-flex align-items-center gap-2'>
                                {request?.status === 'pending' && <Button variant="danger" onClick={() => setShowReject(true)} disabled={loadingSubtract}> Rechazar </Button>}
                            </div>

                            {request?.status === 'pending' &&
                                <div className='d-flex align-items-center gap-2'>
                                    <div className='d-flex align-items-center gap-2'>
                                        <Button variant="primary" className='d-flex align-items-center gap-2' onClick={verifyAndSubmit} disabled={loadingSubtract}>
                                            {loadingSubtract ? <Spinner animation="border" size="sm" /> : <BsDashCircleFill size={20} />} Bajar Fichas
                                        </Button>
                                    </div>
                                </div>
                            }

                            {request?.status === 'approved' &&
                                <div className='d-flex align-items-center gap-2'>
                                    <div className='text-success'>
                                        El retiro ya fue realizado.
                                    </div>
                                </div>
                            }

                            {request?.status === 'rejected' &&
                                <div className='d-flex align-items-center gap-2 mx-2'>
                                    <div className='text-danger'>
                                        El retiro fue rechazado.
                                        <br />
                                        <span className='text-secondary'>Motivo: {request.reason}</span>
                                    </div>
                                </div>
                            }

                            {request?.status === 'pendingpayment' &&
                                <div className='d-flex align-items-center gap-2 mx-2'>
                                    <div className='text-danger'>
                                        Fichas Bajadas - Pendiente De Pago
                                    </div>
                                </div>
                            }

                        </div>
                    </Modal.Footer>
                </div >
            </Modal >
        </>
    )
}
